import { render, staticRenderFns } from "./Diurese.vue?vue&type=template&id=4f9754b4&"
import script from "./Diurese.vue?vue&type=script&lang=js&"
export * from "./Diurese.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports